import { isSlotOutsideBookingWindow } from 'app/ProviderSearch/utils'

/**
 * Earliest bookable slot across the currently loaded date range, falling back
 * to the provider's backend-computed next availability when the local search
 * comes up empty. Shared by desktop (StickyScheduleSection) and mobile
 * (SlotGridBody) for the Primary Book Button default preselection.
 */
export const getNextOpeningSlot = (
  dateSlots: DateSlot,
  bookingWindowHours: number,
  nextAvailabilityForProviders: NextAvailabilityMap | null,
  providerId: string
): ProviderSlot | null =>
  Object.values(dateSlots || {})
    .flat()
    .filter(
      (slot) =>
        !!slot && isSlotOutsideBookingWindow(slot?.start, bookingWindowHours)
    )
    .sort(
      (a, b) => new Date(a.start).getTime() - new Date(b.start).getTime()
    )[0] ||
  nextAvailabilityForProviders?.[providerId] ||
  null

export default getNextOpeningSlot
